import React, { useState } from 'react';
import cn from 'classnames';
import style from './index.module.scss';
import Transition from 'components/transition';
const TabPanel = (props: { list: Array<{ [key: string]: any }>; title: string; titleDesc?: string; className?: string }) => {
  const { list, title, titleDesc = '', className = '' } = props;
  const [current, setCurrent] = useState(0);
  const desc = list[current].mDesc || list[current].desc;

  return (
    <>
      <div className={cn(style.tab, className)}>
        <Transition delay={0.5}>
          <div className={'title'}>{title}</div>
          {titleDesc && <div className="titleDesc">{titleDesc}</div>}
        </Transition>

        <Transition delay={0.8}>
          <div className={'navs'}>
            {list.map((item: any, index) => {
              return (
                <div key={item.title} onClick={() => setCurrent(index)} className={cn('nav', index === current && 'nav-active')}>
                  {item.title}
                </div>
              );
            })}
          </div>
          <div className={'full-content'}>
            <div className={'fun-img'}>
              <img src={list[current].imgUrl} alt="" />
            </div>
            <div className={'text'}>
              {list[current].name && <div className={'name'}>{list[current].name}</div>}
              <div
                className={'desc'}
                dangerouslySetInnerHTML={{
                  __html: desc.replace(/\n/g, '<br/>'),
                }}
              ></div>
            </div>
          </div>
        </Transition>
      </div>
    </>
  );
};

export default TabPanel;
